export default __webpack_public_path__ + "static/media/chainIcon.999a28a3.svg";